// src/api/services/sessions.service.ts

import axiosInstance from '../axios.config';
import { API_ENDPOINTS } from '../endpoints'; // Keep as 'endpoint' to match your file
import { AudioSession, PaginatedResponse, ApiResponse } from 'types';
import { mockSessions } from 'mocks/mockServer';
import { dateStringToEpoch, dateStringToEpochEndOfDay } from 'utils/helpers';

const useMock = process.env.REACT_APP_USE_MOCK === 'true';

export const sessionsService = {
  async getAudioSessions(params?: any): Promise<ApiResponse<PaginatedResponse<AudioSession>>> {
    if (useMock) {
      return mockSessions.getAudioSessions(params);
    }

    // Convert date strings to epoch timestamps for API
    const apiParams: any = { ...params };
    if (params?.dateFrom) {
      apiParams.fromDateEpoch = dateStringToEpoch(params.dateFrom);
      delete apiParams.dateFrom;
    }
    if (params?.dateTo) {
      apiParams.toDateEpoch = dateStringToEpochEndOfDay(params.dateTo);
      delete apiParams.dateTo;
    }
    // Convert frontend 1-based page to backend 0-based page
    if (params?.page !== undefined) {
      apiParams.page = Math.max(0, params.page - 1);
    }

    try {
      const response = await axiosInstance.get<ApiResponse<PaginatedResponse<AudioSession>>>(
        API_ENDPOINTS.AUDIO_SESSIONS,
        { params: apiParams }
      );

      // API returns wrapped response: { success, message, data }
      return response.data;
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch audio sessions'
      };
    }
  },

  async getSessionDetail(id: number): Promise<ApiResponse<AudioSession>> {
    if (useMock) {
      return mockSessions.getSessionDetail(id);
    }

    try {
      const response = await axiosInstance.get<ApiResponse<AudioSession>>(
        API_ENDPOINTS.AUDIO_SESSION_DETAIL(id)
      );

      // API returns wrapped response: { success, message, data }
      return response.data;
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch session details'
      };
    }
  }
};